<template>
  <div>
    <main-navigation></main-navigation>

    <div class="dash-page">
      <div class="dash-shell">
        <div class="dash-head">
          <h2 class="dash-head__title">Water Bills</h2>
        </div>

        <!-- SUMMARY -->
        <div class="dash-grid mb-3">
          <div class="dash-stat">
            <span class="dash-stat__label">Total Bills</span>
            <h3 class="dash-stat__value">{{ bills.length }}</h3>
          </div>

          <div class="dash-stat">
            <span class="dash-stat__label">Total Amount</span>
            <h3 class="dash-stat__value">KES {{ totalAmount.toLocaleString() }}</h3>
          </div>
        </div>

        <!-- SEARCH -->
        <div class="search-box">
          <input
            v-model="search"
            placeholder="Search by unit or tenant..."
          />
        </div>

        <!-- LOADING -->
        <div v-if="loading" class="dash-state">
          <div class="dash-spinner"></div>
          <p>Loading bills...</p>
        </div>

        <!-- ERROR -->
        <div v-if="error" class="dash-badge dash-badge--danger mb-3">
          {{ error }}
        </div>

        <!-- TABLE -->
        <div v-if="!loading && filteredBills.length" class="dash-card">
          <div class="dash-table-wrap">
            <table class="dash-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Unit</th>
                  <th>Tenant</th>
                  <th>Previous</th>
                  <th>Current</th>
                  <th>Consumption</th>
                  <th>Amount</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="bill in filteredBills" :key="bill.id">
                  <td>{{ bill.id }}</td>
                  <td>{{ bill.unit_number }}</td>
                  <td>{{ bill.tenant_name || "Vacant" }}</td>
                  <td>{{ bill.previous_reading }}</td>
                  <td>{{ bill.current_reading }}</td>
                  <td>{{ bill.consumption }}</td>
                  <td class="num amount">KES {{ bill.amount }}</td>
                  <td>{{ formatDate(bill.createdAt) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="!loading && !filteredBills.length" class="dash-state">
          <i class="bi bi-droplet" style="font-size: 2rem;"></i>
          <p>No bills found</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: "BillsList",

  data() {
    return {
      bills: [],
      loading: true,
      error: "",
      search: ""
    };
  },

  computed: {

    filteredBills() {
      return this.bills.filter(bill => {

        const unit = bill.unit_number || "";
        const tenant = bill.tenant_name || "";

        return (
          unit.toLowerCase().includes(this.search.toLowerCase()) ||
          tenant.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },

    totalAmount() {
      return this.bills.reduce((sum, bill) => {
        return sum + Number(bill.amount || 0);
      }, 0);
    }

  },

  methods: {

    async fetchBills() {
      try {

        const token = localStorage.getItem("token");

        const res = await fetch("https://golang.roberms.com/api/get/bills", {
          headers: { Authorization: `Bearer ${token}` }
        });

        const data = await res.json();

        this.bills = Array.isArray(data) ? data : data.data || [];

      } catch (e) {

        console.error(e);
        this.error = "Failed to load bills";

      } finally {

        this.loading = false;

      }
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString();
    }

  },

  mounted() {
    this.fetchBills();
  }

};
</script>

<style scoped>

.search-box {
  margin-bottom: 20px;
}

.search-box input {
  padding: 10px;
  width: 260px;
  border: 1px solid var(--dash-line);
  border-radius: var(--dash-radius);
}

.amount {
  font-weight: bold;
  color: var(--dash-success);
}

</style>